webpackJsonp([91],{

/***/ "6p0q":
/***/ (function(module, exports, __webpack_require__) {

var SectionDifferentDevices = (function () {
    function SectionDifferentDevices() {
    }
    return SectionDifferentDevices;
}());
angular.module('animatronApp.sectionDifferentDevices', []).component('sectionDifferentDevices', {
    bindings: {
        ltTitle: '<',
        buttons: '<?',
        description: '<',
        videos: '<'
    },
    controller: SectionDifferentDevices,
    templateUrl: __webpack_require__("w7UM")
});


/***/ }),

/***/ "w7UM":
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "html/section-different-devices_a2ca0266b02b550f62fc07fcf6ea6d56.html";

/***/ })

});


// WEBPACK FOOTER //
// javascripts/91-257c10c0995a4d25fa59.min.js